/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TensionGuide_tension$ref: FragmentReference;
declare export opaque type TensionGuide_tension$fragmentType: TensionGuide_tension$ref;
export type TensionGuide_tension = {|
  +id: string,
  +databaseId: string,
  +impactedRole: ?{|
    +governanceEnabled: boolean
  |},
  +$refType: TensionGuide_tension$ref,
|};
export type TensionGuide_tension$data = TensionGuide_tension;
export type TensionGuide_tension$key = {
  +$data?: TensionGuide_tension$data,
  +$fragmentRefs: TensionGuide_tension$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TensionGuide_tension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "impactedRole",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "governanceEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Tension",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'f23ac48bb51c850a12d1298a4bd0d20a';

module.exports = node;
